const getDefaultState = function () {
    return {
        // These are for holding the available options
        availableGearboxes: [],
        availableFuelTypes: [],
        availableFuelTypesAreFor: null,
        availableTrims: [],
        availableTrimsAreFor: null,
        availableEngines: [],
        availableEnginesAreFor: null,
        availableInteriors: [],
        availableInteriorsAreFor: null,
        availablePaints: null,
        availablePaintsAreFor: null,

        // These are for building the images
        paintOptions: [],

        // These are the customer selections
        brand: null,
        manufacturer: null,
        model: null,
        gearboxChoice: null,
        fuelTypeChoice: null,
        trimChoice: null,
        trimYear: null,
        engineChoice: null,
        vehicleId: null,
        paintChoice: null,
        interiorChoice: null,
        configuratorId: null,
        firstName: null,
        lastName: null,
        email: null,
        selectedVehiclePrice: null,
        selectedPaintPrice: null,
        selectedInteriorName: null,
        selectedInteriorPrice: null,

        customerDetailsSubmitted: false,

        selectedNewVehicle: null,
        selectedNewVehicleIdentifier: null,
        selectedNewVehicleIdentifierType: null,
        pcpVehicleRequest: null,
        hpVehicleRequest: null,
    };
};

export {getDefaultState};


// WEBPACK FOOTER //
// ./resources/assets/js/configurator/store/modules/defaultState.js